/* eslint-disable */

export enum LiveSalesType {
  NOT_USED = 0,
  GLOBAL = 1,
  COUNTRY = 2,
  STORE = 3,
  UNRECOGNIZED = -1,
}

export interface HfbLiveSalesData {
  hfbNo: string;
  hfbCaption: string;
  retailUnitCode: string;
  retailUnitName: string;
  marketAreaNo: string;
  marketAreaCaption: string;
  totalSales: number;
  totalGoal: number;
  salesString?:
    | string
    | undefined;
  /** set on client */
  goalString?: string | undefined;
  performance?: number | undefined;
}

export interface LiveSalesData {
  hfbList: HfbLiveSalesData[];
  totalSales: number;
  totalGoal: number;
  marketAreaCaption: string;
  marketAreaNumber: string;
  retailUnitName: string;
  retailUnitCode: string;
  currencyCode: string;
  lastFetched: string;
  type: LiveSalesType;
  performance: number;
  /** set on client side */
  salesString?: string | undefined;
  goalString?: string | undefined;
  favoriteHfbList: HfbLiveSalesData[];
  yesterdaySales: LiveSalesData | undefined;
}

export interface LiveSalesRequest {
  unitName: string;
}

export interface LiveSalesResponse {
  item: LiveSalesData | undefined;
}
